<template>
  <div class="img-preview-btn" v-if="canPreview">
    <hmd-empty-link @click="show">预览</hmd-empty-link>

    <div class="images" v-viewer="{ movable: false }">
      <img :src="url" width="0" height="0" style="display: none" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { component as Viewer } from "v-viewer";
import { getFileExt } from "@/utils";

export default defineComponent({
  isGlobal: true,
  name: "ImgPreviewBtn",
  components: { Viewer },
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  computed: {
    canPreview() {
      const ext = getFileExt(this.url || "");
      return ["png", "jpg", "jpeg"].includes(ext);
    },
  },
  methods: {
    show() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
  },
});
</script>

<style lang="less" scoped>
.img-preview-btn {
  display: inline-block;
}
</style>
